import { buildCreateSlice, PayloadAction } from '@reduxjs/toolkit';

import { HeaderStateType } from '../types/headerStateType';

const createAppSlice = buildCreateSlice();

const initialState: HeaderStateType = {
  hideSearch: false,
  openMobileMenu: false
};

export const headerSlice = createAppSlice({
  name: 'header',
  initialState,
  reducers: (create) => ({
    toggleSearch: create.reducer((state, action: PayloadAction<boolean>) => {
      state.hideSearch = action.payload;
    }),
    toggleMobileMenu: create.reducer((state, action: PayloadAction<boolean>) => {
      state.openMobileMenu = action.payload;
    })
  })
});

export const { toggleSearch, toggleMobileMenu } = headerSlice.actions;

export const headerReducer = headerSlice.reducer;
